<template>
    <div 
        class="lg:col-span-9 w-full flex flex-col max-h-screen  bg-gray-100 border-l-gray-300 border-l dark:bg-slate-800/5  dark:border-l-gray-700 justify-center items-center">
        <img src="@/assets/empty.svg" class="w-72 h-72 " alt="">
        <div class="text-xl dark:text-gray-200 text-teal-950 font-bold">Aucune conversation n'est selectionnée</div>
    </div>
</template>
<script>
export default {
    name:"MessageEmpty"
}
</script>